import { render, staticRenderFns } from "./Patrimoine.vue?vue&type=template&id=f8f8b0f6&scoped=true&"
import script from "./Patrimoine.vue?vue&type=script&lang=js&"
export * from "./Patrimoine.vue?vue&type=script&lang=js&"
import style0 from "./Patrimoine.vue?vue&type=style&index=0&id=f8f8b0f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f8b0f6",
  null
  
)

export default component.exports